// extracted by mini-css-extract-plugin
export default {"button-as-link":"Button_button-as-link__o0a5d","default":"Button_default__ES2Jb"};